<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="primary white--text title"
        >Submit 5G Order</v-card-title
      >

      <v-card-text class="pt-10 subtitle-2">{{ text }}</v-card-text>

      <v-card-actions class="pt-0 pb-3 px-3">
        <v-spacer></v-spacer>
        <v-btn class="primary" text @click="$emit('submitOrder')"
          >Confirm</v-btn
        >
        <v-btn text @click="close()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PromptDialog",
  props: {
    dialog: { type: Boolean },
    text: { type: String },
  },
  methods: {
    close() {
      this.$emit("closePrompt");
    },
  },
};
</script>
